import * as React from 'react';
import {ComponentExt} from '@utils/reactExt';
import CRouterE from '@router/routerE';

export default class EsimApp extends ComponentExt<any> {
    render() {
        return (
            <CRouterE location={this.props.location} />
        );
    }
}
